export const originalAccordionHistory = () => {
  document.querySelectorAll(".accordion-item-wrapper").forEach(wrapper => {
    const item = wrapper.querySelector(".accordion-item");
    const head = item.querySelector(".history-head");
    const body = item.querySelector('.history-body-left');
    const firstItem = item.querySelector(".in-cart-item-list .item");
    const toggleBtn = wrapper.querySelector(".toggle-btn");

    const getCollapsedHeight = () =>
      head.offsetHeight + body.offsetHeight + (firstItem?.offsetHeight || 0);

    let isExpanded = false;

    // 初期スタイル
    item.style.height = getCollapsedHeight() + "px";
    item.style.overflow = "hidden";
    item.style.transition = "height 0.6s ease";

    toggleBtn.addEventListener("click", () => {
      if (!isExpanded) {
        // 展開処理
        const fullHeight = item.scrollHeight;

        requestAnimationFrame(() => {
          item.style.height = fullHeight + "px";
        });

        item.classList.add("open");
        toggleBtn.textContent = "閉じる";
      } else {
        // 折りたたみ処理
        item.style.height = getCollapsedHeight() + "px";
        item.classList.remove("open");
        toggleBtn.textContent = '注文内容を見る';
      }

      isExpanded = !isExpanded;
    });

    // リサイズ対応（必要に応じて）
    window.addEventListener("resize", () => {
      if (!isExpanded) {
        item.style.height = getCollapsedHeight() + "px";
      }
    });
  });

};
